import { render, staticRenderFns } from "./viewSubClinic.vue?vue&type=template&id=18a3ff4f&"
import script from "./viewSubClinic.vue?vue&type=script&lang=js&"
export * from "./viewSubClinic.vue?vue&type=script&lang=js&"
import style0 from "./viewSubClinic.vue?vue&type=style&index=0&id=18a3ff4f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports